import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="relative w-full aspect-[21/9] rounded-2xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Lifestyle%20flat%20lay%20of%20stylish%20shopping%20bag%20with%20tissue%20paper%20next%20to%20a%20laptop%20displaying%20spreadsheet%20on%20screen%20surrounded%20by%20small%20fashion%20accessories%20on%20a%20warm%20cream%20desk%20surface%20soft%20golden%20hour%20sunlight%20streaming%20through%20sheer%20curtains%20creating%20cozy%20modern%20home%20office%20atmosphere%20editorial%20photography&width=1600&height=686&seq=kakobuy-cta-v3&orientation=landscape"
              alt="Kakobuy Spreadsheet - produkty premium"
              className="w-full h-full object-cover"
            />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold text-foreground-900 leading-tight mb-4">
            {t('section_cta_title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto mb-10">
            {t('section_cta_desc')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-10 py-4 rounded-full bg-primary-800 text-white text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-900 transition-colors cursor-pointer"
            >
              {t('btn_spreadsheet')}
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-10 py-4 rounded-full border border-foreground-200 text-foreground-700 text-sm md:text-base font-medium whitespace-nowrap hover:bg-foreground-50 transition-colors cursor-pointer"
            >
              {t('btn_buy_now')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}